"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

var _moment = _interopRequireDefault(require("moment"));

var _CustomDateInput = _interopRequireDefault(require("./CustomDateInput"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sharedCss = _interopRequireDefault(require("../../shared/oldDocumentSignerUI/sharedCss"));

var _fieldStatusClass = _interopRequireDefault(require("./fieldStatusClass"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = function styles(theme) {
  return _objectSpread({}, _sharedCss.default.fields, {
    root: {
      position: 'absolute'
    },
    input: {
      color: 'black'
    }
  });
};

var getValidMoment = function getValidMoment(value, defaultValue, format) {
  if (!value) return null;
  if (value === defaultValue) return value;
  var m = (0, _moment.default)(value, format);
  if (!m.isValid()) return null;
  return m;
};

var getMomentValue = function getMomentValue(value, format) {
  return value && value.isValid && value.isValid() ? value.format(format) : value;
};

var DatePicker = function DatePicker(props) {
  var id = props.id,
      _props$format = props.format,
      format = _props$format === void 0 ? 'MM/DD/YYYY' : _props$format,
      x = props.x,
      y = props.y,
      height = props.height,
      width = props.width,
      handleChange = props.handleChange,
      classes = props.classes,
      value = props.value,
      setFieldRef = props.setFieldRef,
      defaultValue = props.defaultValue,
      _props$_derived = props._derived,
      isRequired = _props$_derived.isRequired,
      isDisabled = _props$_derived.isDisabled;
  var fieldDynamicStyle = {
    top: y,
    left: x,
    height: height,
    width: width
  };

  var filteredProps = _objectSpread({}, props, {
    fieldId: id
  }); // DataPicker overwrites our id prop


  delete filteredProps.classes;
  var dateFormat = format ? format.toUpperCase() : 'MM/DD/YYYY';
  var validMoment = getValidMoment(value, defaultValue, dateFormat);

  var onChange = function onChange(v) {
    var m = getValidMoment(v, '', dateFormat);
    var value = m && m.format && m.format(dateFormat) || m;
    handleChange(value);
  };

  return _react.default.createElement("div", {
    className: classes.root,
    style: fieldDynamicStyle
  }, _react.default.createElement(_reactDatepicker.default, {
    ref: function ref(e) {
      return setFieldRef(e, y);
    },
    customInput: _react.default.createElement(_CustomDateInput.default, filteredProps),
    onChange: onChange,
    placeholderText: isRequired ? 'Required' : 'Click to select a date',
    selected: _typeof(validMoment) === 'object' && validMoment || null,
    value: getMomentValue(validMoment, dateFormat),
    disabled: isDisabled,
    className: (0, _classnames.default)(classes.input, (0, _fieldStatusClass.default)(props)),
    dateFormat: dateFormat,
    popperModifiers: {
      preventOverflow: {
        boundariesElement: 'scrollParent'
      }
    },
    "data-test-id": "DatePicker-picker-".concat(id)
  }));
};

DatePicker.propTypes = {
  classes: _propTypes.default.object.isRequired
};

var _default = (0, _styles.withStyles)(styles)(DatePicker);

exports.default = _default;